import { render, staticRenderFns } from "./AverageInvestmentByMonth.vue?vue&type=template&id=af409668&"
import script from "./AverageInvestmentByMonth.vue?vue&type=script&lang=ts&"
export * from "./AverageInvestmentByMonth.vue?vue&type=script&lang=ts&"
import style0 from "./AverageInvestmentByMonth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports